import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authSlice } from './auth';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { menuSlice } from './menu';
import { canappApi } from 'services';

const persistConfig = {
    key: 'root',
    storage
};

const rootReducer = combineReducers({
    authentication: authSlice.reducer,
    menu: menuSlice.reducer,
    [canappApi.reducerPath]: canappApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }).concat(canappApi.middleware)
});

export type AppStore = typeof store;

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
